import { connect } from 'react-redux';

import { getPermissions } from '../Login/selectors';
import { setSelectedSP } from '../Rates/actions';
import {
  createRate,
  deleteSP,
  loadQuals,
  loadRates,
  updateSP,
} from '../Rates/actionsSagas';
import { getQuals, getRates, getSelectedSP } from '../Rates/selectors';
import StudyPrograms from './StudyPrograms';

const mapStateToProps = (state) => ({
  rates: getRates(state),
  quals: getQuals(state),
  selectedSP: getSelectedSP(state),
  permissions: getPermissions(state),
});

const mapDispatchToProps = (dispatch) => ({
  loadRates: (page) => dispatch(loadRates(page)),
  loadQuals: (page) => dispatch(loadQuals(page)),
  onSPClick: (sp) => dispatch(setSelectedSP(sp)),
  onCreate: (sp) => dispatch(createRate(sp)),
  onEdit: (sp) => dispatch(updateSP(sp)),
  onDelete: (sp) => dispatch(deleteSP(sp)),
});

export default connect(mapStateToProps, mapDispatchToProps)(StudyPrograms);
